import type React from 'react'
import type { JSX } from 'react'
import type { Animations } from 'blocks/AnimatedWrapper'
import type { FIXED_INDENTS, LAYOUT, SHADOW } from 'vars/index'

import { useCallback, useEffect, useRef } from 'react'
import { AnimatedWrapper } from 'blocks/AnimatedWrapper'
import { CORNERS } from 'vars/index'
import { SidebarSkeleton } from './components/SidebarSkeleton'
import { SidebarPositions } from './SidebarComponent.h'
import { SidebarComponentSC } from './SidebarComponent.styled'

export interface ISidebarComponentProps {
  isLoading?: boolean
  isOpen: boolean
  isCloseBtnShown?: boolean
  onClose?: () => void

  children?: React.ReactNode
  transitionName: Animations
  position?: SidebarPositions
  sidebarShadow?: SHADOW
  horizontalPaddings?: LAYOUT | FIXED_INDENTS
  corners?: CORNERS
}

export const SidebarComponent = ({
  isLoading = false,

  isOpen,
  isCloseBtnShown,
  onClose,

  children,
  transitionName,
  position = SidebarPositions.Right,
  sidebarShadow,
  horizontalPaddings,
  corners = CORNERS.CORNERS_0,
}: ISidebarComponentProps): JSX.Element => {
  const sidebarRef = useRef<HTMLDivElement>(null)

  const handleEscButton = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Escape' && onClose) onClose()
    },
    [onClose]
  )

  useEffect(() => {
    window.addEventListener('keydown', handleEscButton)
    return () => window.removeEventListener('keydown', handleEscButton)
  }, [handleEscButton])

  return (
    <AnimatedWrapper transitionName={transitionName} transitionTrigger={isOpen}>
      <SidebarComponentSC
        ref={sidebarRef}
        isOpen={isOpen}
        position={position}
        shadow={sidebarShadow!}
        horizontalPaddings={horizontalPaddings!}
        corners={corners}
      >
        {isLoading ? (
          <SidebarSkeleton
            isCloseBtnShown={isCloseBtnShown!}
            onClose={onClose!}
          />
        ) : (
          children
        )}
      </SidebarComponentSC>
    </AnimatedWrapper>
  )
}
